import { CancelToken } from 'axios';
import { omit } from 'lodash';
import { appConfig } from '../config/app-config';
import { getTokens } from './client';
import {
  GET_STORES_LIMIT,
  ProductPermissions,
  statesOfUS,
} from '../constants/constants';
import { Store } from '../domain/Store';
import {
  StoreDetailResponse,
  StoreConfigsPayload,
  StoreConfigsResponse,
  State,
} from '../types/types';
import { client } from './client';
import jwtDecode from 'jwt-decode';

const currentMenuURL = appConfig.apiUrls.menu;

export const getStoreDetailByNumber = (
  storeNumber: string,
  cancelToken?: CancelToken
): Promise<StoreDetailResponse> => {
  return client(
    `stores/${storeNumber}/details`,
    {
      method: 'GET',
      headers: {
        storenumber: storeNumber,
      },
      cancelToken,
    },
    appConfig.apiUrls.am,
    true
  );
};

export const getStoreConfigs = async (
  payload: StoreConfigsPayload
): Promise<StoreConfigsResponse[]> => {
  return client(
    `config/get-store-profile`,
    {
      method: 'POST',
      body: payload,
    },
    appConfig.apiUrls.micro,
    true
  );
};

const addStateToStore = (store: any): Store => {
  const state: State = {
    abbreviation: store.storeState,
    name:
      statesOfUS.find((state: State) => state.abbreviation === store.storeState)
        ?.name || '',
  };

  return omit(
    {
      ...store,
      state,
    },
    ['storeState']
  ) as Store;
};

export const getUserPermissions = (
  productType = 'RPDMANPO'
): Promise<ProductPermissions[]> =>
  client(`users/current/permissions/${productType}`, { method: 'GET' });

export const getStores = (
  term = '',
  cancelToken: CancelToken,
  limit = GET_STORES_LIMIT
) => {
  const params: any = {};

  if (term) {
    params.q = `storeNum[:includes]=${term}`;
  }

  params.limit = limit;

  return client(
    'users/current/stores',
    {
      method: 'GET',
      params,
      cancelToken,
    },
    appConfig.apiUrls.container
  ).then((stores: Store[]) => {
    return stores.map(addStateToStore);
  });
};

// New function to get menu and stores from RAC DB.
export const getmenuandstore = async (falg?: any, getRole?: boolean) => {
  try {
    const jwtToken = (await getTokens(true)) || '';
    const decodedToken: any = jwtDecode(jwtToken.idToken as string);
    // eslint-disable-next-line no-console
    console.log('decodedToken', decodedToken);
    const parameters: any = {
      coworkerId: decodedToken['custom:employeeId'],
    };
    if (falg == 'MENU') {
      parameters.storesRequired = true;
      parameters.menuRequired = true;
      parameters.menuRequest = {
        association: {
          associationCode: sessionStorage.getItem('storeNumber'),
          associationType: 'STORE',
        },
      };
    }
    return await client(
      'menu-and-stores',
      { method: 'POST', body: parameters },
      currentMenuURL,
      true
    ).then((response: any) => {
      if (getRole) {
        return response.coworkerProfile.role;
      } else return response.storeAssignment.map(addStateToStoreV2);
    });
  } catch (e: any) {
    return null;
  }
};

// New function to map state and return store object.
const addStateToStoreV2 = (store: any): Store => {
  const state: State = {
    abbreviation: store?.storeDetails?.state,
    name:
      statesOfUS.find(
        (state: State) => state?.abbreviation === store?.storeDetails?.state
      )?.name || '',
  };

  return omit(
    {
      storeId: store?.orgHierarchyId,
      storeNum: store?.accountingUnitNumber,
      storeName: store?.storeDetails?.storeName,
      franchiseeName: store?.franchiseeName || 'Corporate',
      franchiseeStore: store?.franchiseeStore || false,
      state: state,
      simsStore: store?.storeDetails?.posType == 'SIMS' ? true : false,
      startDate: store?.storeDetails?.openDate,
      endDate: store?.storeDetails?.closeDate,
    },
    ['storeState']
  ) as Store;
};
